import { camelCase } from '@cc-shopping/utils/string/camelCase';
import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

export const getDriverIntroOffer = (
  marketplaceEntity: MarketplaceEntity,
): MarketplaceDriverConfig | null => {
  if (!marketplaceEntity.driverIntroOffer) return null;
  return {
    id: camelCase(marketplaceEntity.driverIntroOffer.label),
    label: marketplaceEntity.driverIntroOffer.label,
    value: marketplaceEntity.driverIntroOffer.value,
    description: marketplaceEntity.driverIntroOffer.description,
    labelTooltip: undefined,
    valueTooltip: marketplaceEntity.driverIntroOffer.valueTooltip,
    valueTooltipHasHtml: false,
  };
};
